import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    tabNav: {
        backgroundColor: theme.palette.tabs.main,
    },
}));
